import axios from "axios";
import { primaryToken, secondaryToken } from "../constants/app-constants";
import axiosClient from "./api-handlers";
import axiosCMS from "./cms-api-handlers";
import axiosMHClient from "./second-api-handlers";

const httpHeaderWithPrimaryToken = {
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "aggregatorType": "market_place",
    "apitoken": primaryToken,
  },
};

const httpHeaderWithSecondaryToken = {
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "aggregatorType": "opd_emr",
    "apitoken": secondaryToken,
  },
};

export async function getImageFromCMS(page, section) {
  const response = await axiosCMS.get(`imgs/${page}/${section}`);
  return response;
}

export async function getTextFromCMS(page, section) {
  const response = await axiosCMS.get(`txts/${page}/${section}`);
  return response;
}

export async function countries() {
  const response = await axiosClient.get(`/template-parts/order-medicine/countries.json`);
  return response;
}

export async function indianCities(diagnostic, page) {
  const response = await axiosClient.get(`/patients/web/v2/patients/indian-city?is_diagnostic=${diagnostic}&page=${page}`);
  return response;
}
export async function searchindianCities(search) {
  const response = await axiosClient.get(`/patients/web/v2/patients/get-indian-city?search=${search}`,httpHeaderWithPrimaryToken);
  return response;
}

export async function configurations() {
  const response = await axiosClient.get(`/patients/web/v2/configurations`);
  return response;
}

export async function hospitalByCity(lat, lng) {
  const response = await axiosClient.get(`/patients/web/v2/hospitals-by-city?lat=${lat}&lng=${lng}`);
  return response;
}

export async function specialitiesListByHospital(id) {
  const response = await axiosClient.get(`/patients/web/v2/specialities?hospital_id=${id}`);
  return response;
}

export async function getHospitals(id) {
  const response = await axiosClient.get(`/patients/web/v2/hospitals/${id}`);
  return response;
}

export async function clinicDistance() {
  const response = await axiosClient.get(`/patients/web/v2/patinets/clinic-distance`);
  return response;
}

export async function getDocAvailability() {
  const response = await axiosClient.get(`/patients/web/v2/doctors/2054/availability`);
  return response;
}

export async function getProfile(JWT) {
  const response = await axiosClient.get(
    `/patients/web/v2/patients/profile`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

export async function getProfileWithPayload(payload, token) {
  const response = await axiosClient.get(
    `/patients/web/v2/patients/profile` + payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    }
  );
  return response;
}

export async function familyMember(familyMember) {
  const response = await axiosClient.get(`/specialities/75/doctors/2057/user/account/${familyMember}`);
  return response;
}

export async function timeslots(time) {
  const response = await axiosClient.get(`/patients/web/v2/doctors/1630/availability-timeslots?${time}`);
  return response;
}

export async function pincodeByCity(city) {
  const response = await axios.get(`https://api.postalpincode.in/postoffice/${city}`);
  return response;
}

export async function indianPincode(pincode, vendor_id) {
  const response = await axiosClient.get(
    vendor_id ? `/patients/web/v2/patients/get-indian-pincode?pincode=${pincode}&vendor_id=${vendor_id}` : `/patients/web/v2/patients/get-indian-pincode?pincode=${pincode}`,
    httpHeaderWithPrimaryToken);
  return response;
}

export async function getLatLongDetail(lat, long) {
  if (!lat || !long) {
    return;
  }
  const response = await axiosClient.get(`/patients/web/v2/maps/geolatlong/${lat}/${long}`,
    httpHeaderWithSecondaryToken
  );
  return response;
}

export async function getTimeslotByHospital(vendor_id, city_id, visit_date, pincode, locality = "") {
  const response = await axiosClient.get(`/patients/web/v2/patients/lalpath-slots-availability?vendor_id=${vendor_id}&city_id=${city_id}&visit_date=${visit_date}&pincode=${pincode}&zipcode=${pincode}&locality=${locality}`,
    httpHeaderWithPrimaryToken);
  return response;
}

export async function thyrocareDetail(id, pincode) {
  const response = await axiosClient.get(`/patients/web/v2/patients/thyrocare-test-Details?diagnosis_id=${id}&pincode=${pincode}`,
    httpHeaderWithPrimaryToken);
  return response;
}

export async function thyrocareList(type, category, pincode, page, keyword) {
  keyword = keyword ? "&keyword=" + keyword : type === 2 ? "&category=" + category : "";
  const response = await axiosClient.get(`/patients/web/v2/patients/thyrocare-list-products?type=${type}&pincode=${pincode}&page=${page}${keyword}`,
    httpHeaderWithPrimaryToken);
  return response;
}

export async function testDetails(payload) {
  const searchParams = new URLSearchParams(payload);
  const response = await axiosClient.get(`/patients/web/v2/patients/get-test-details?` + searchParams,
    httpHeaderWithPrimaryToken);
  return response;
}

export async function vendorCities(id) {
  const response = await axiosClient.get(`/patients/web/v2/patients/lalpath-cities?vendor_id=${id}`,
    httpHeaderWithPrimaryToken);
  return response;
}

export async function getOneMGPincode(pincode) {
  const response = await axiosClient.get(`/patients/ios/v2/website/get-onemgpincode?pincode=${pincode}`,
    httpHeaderWithPrimaryToken);
  return response;
}

export async function getOrderMedicinePincode(pincode) {
  const response = await axiosClient.get(`/patients/ios/v2/website/get-medicine-order-pincode?pincode=${pincode}`,
    httpHeaderWithPrimaryToken);
  return response;
}

export async function getHomecareCategory() {
  const response = await axiosClient.get(`/patients/ios/v2/test/homecare-category`);
  return response;
}

export async function getHospitalListingByCat(catId) {
  const response = await axiosClient.get(`/patients/ios/v2/hospitals-by-city?category_id=${catId}&is_homecare=1`);
  return response;
}

export async function packageByHospital(catId, hospitalId, page, type) {
  const response = await axiosClient.get(`/patients/ios/v2/test-list-by-category?category_id=${catId}&hospital_id=${hospitalId}&page=${page}&type=${type}`);
  return response;
}

export async function packageDetails() {
  const response = await axiosClient.get(`/patients/ios/v2/test/hospital_id/28/test/75`);
  return response;
}

export async function packageAvailability() {
  const response = await axiosClient.get(`/patients/ios/v2/test?hospital_id=28&testid=75`);
  return response;
}

export async function doctorAvailability(specialId, hospitalId, keyword) {
  keyword = keyword !== "" ? "&keyword=" + keyword : "";
  const response = await axiosClient.get(`/patients/web/v2/specialities/${specialId}/doctors?hospital_id=${hospitalId}${keyword}`);
  return response;
}

export async function doctorImmediateAvailability(specialId, hospitalId) {
  const response = await axiosClient.get(`/patients/web/v2/specialities/${specialId}/immediate-doctors?hospital_id=${hospitalId}`);
  return response;
}

export async function specialityInfoById(Id) {
  const response = await axiosClient.get(`/patients/web/v2/specialities/${Id}`);
  return response;
}

export async function doctorProfileById(docId, hospitalId) {
  const response = await axiosClient.get(`/patients/web/v2/doctors/${docId}?hospital_id=${hospitalId}`);
  return response;
}

export async function doctorAvailabilityById(Id) {
  const response = await axiosClient.get(`/patients/web/v2/doctors/${Id}/availability`);
  return response;
}

export async function doctorTimeSlots(docId, hospitalId, date, consultT) {
  const response = await axiosClient.get(`/patients/web/v2/doctors/${docId}/availability-timeslots?hospital_id=${hospitalId}&date=${date}&consult_type=${consultT}`);
  return response;
}

export async function carePackages() {
  const response = await axiosMHClient.get(`/patients/ios/v2/special-health-offers`);
  return response;
}

export async function getClinicDistance() {
  const response = await axiosMHClient.get(`/patients/web/v2/patinets/clinic-distance`);
  return response;
}
export async function fetchClinicList(){
  // https://prerelease.mhappapis.vc.myhealthcare.co/api/patients/web/v2/specialities?hospital_id=15 - api given by sarthak to integrate.
  const response = await axiosMHClient.get(`/patients/web/v2/specialities?hospital_id=15/`);
  return response
}